module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-event-351d13760b529582c82ad9e465651f25.svg&quot;;"